import { useCreateGithubAppVersion, useDeployApp } from "@/api";

export const useBackgroundTask = () => {
  const [createGithubAppVersion] = useCreateGithubAppVersion();
  const [deployApp] = useDeployApp();

  const startBackgroundTask = async (
    appID: string,
    owner: string,
    repo: string
  ) => {
    try {
      //* Create app version
      const { data: createGithubAppVersionData } = await createGithubAppVersion(
        {
          variables: { appID, owner, repo }
        }
      );

      if (!createGithubAppVersionData) return null;
      if (
        createGithubAppVersionData.appVersionCreateGitHub?.__typename ===
        "GitHubRepositoryNotFound"
      ) {
        console.error("GitHub repository not found");
        return null;
      }
      if (
        createGithubAppVersionData.appVersionCreateGitHub?.__typename !==
        "AppVersion"
      ) {
        return null;
      }

      //* Deploy the app
      const { data: deployAppData } = await deployApp({
        variables: {
          appVersionID: createGithubAppVersionData.appVersionCreateGitHub.id,
          skipMetadataUpdate: true
        }
      });
      if (!deployAppData) return null;

      const deployVersionID = deployAppData.appDeploy.id;
      return deployVersionID;
    } catch (error) {
      console.error("An error occurred during background task:", error);
      return null;
    }
  };

  return { startBackgroundTask };
};
